import { Grid, Group, Text, Title } from '@mantine/core';
import React from 'react';
import prettifiedLabel from '../../constants/labelPrettifier';

const AbTestTotalCounts = ({ total }) => {
  if (Object.keys(total.data).length === 0) {
    return null;
  }

  return (
    <Grid.Col span="auto">
      <Group justify="space-between">
        <Text size="sm" c="dimmed">{prettifiedLabel(total.name)} Count:</Text>
      </Group>
      <Title order={5}>
        <Text fw={700} component="span">{total.data.control.toLocaleString('en-US')}</Text>
      </Title>
      <Title order={5}>
        <Text fw={700} component="span">{total.data.treatment.toLocaleString('en-US')}</Text>
      </Title>
    </Grid.Col>
  );
};

export default AbTestTotalCounts;
